import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import { Grid, Button, MenuItem } from "@mui/material";
import FormikTextField from "../../../../../commons/formik/formikTextField";
import FormikSelect from "../../../../../commons/formik/formikSelect";
import { getTrasladosSearchModel } from "../../../../../../actions/traslados";
import { StyledPaper } from "../../../../../styled/paper";
import { FormikDateRangeSearch, FormikDateRangeInput } from "../../../../../commons/formik/formikDateRangeSearch";

const BuscarTramosFilterPT = ({ initialValues, onSearch, onClear }) => {
  const dispatch = useDispatch();
  const searchModel = useSelector((state) => state.traslados.searchModel);
  const searchModelData = searchModel?.data;

  useEffect(() => {
    if (!searchModelData) {
      dispatch(getTrasladosSearchModel());
    }
  }, [dispatch, searchModelData]);

  const { estados, provincias } = searchModelData || {
    estados: [], provincias: []
  };

  const estadosVisiblesIds = ["4", "5", "6", "10", "11"];
  const estadosFiltrados = (estados || []).filter((e) => estadosVisiblesIds.includes(String(e.id)));
  const provinciasFiltradas = (provincias || [])
    .map((p) => ({ id: p.id?.trim(), name: p.name?.trim() }))
    .filter((p) => p.name && p.name.length > 0 && p.name.toLowerCase() !== "inexistente");

  if (!provinciasFiltradas.some((p) => p.name.toLowerCase() === "capital federal")) {
    provinciasFiltradas.push({ id: "Capital Federal", name: "Capital Federal" });
    provinciasFiltradas.sort((a, b) => a.name.localeCompare(b.name));
  }

  return (
    <StyledPaper.Container sx={{ mb: 2 }}>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => onSearch(values)}
        enableReinitialize
      >
        {({ resetForm }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={2}>
                <FormikTextField name="nroSiniestro" label="Siniestro" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikTextField name="documentoTrabajador" label="Documento Trabajador" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikTextField name="trabajador" label="Trabajador" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikSelect name="estadoTramoId" label="Estado" loading={searchModel?.isFetching} variant="outlined">
                  <MenuItem value="">Todos</MenuItem>
                  {estadosFiltrados.map((e) => (
                    <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>
                  ))}
                </FormikSelect>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormikDateRangeSearch
                  name="datePeriod"
                  label="Período"
                  variant="outlined"
                  startDateFieldName="fechaDesde"
                  endDateFieldName="fechaHasta"
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikDateRangeInput name="fechaDesde" label="Fecha Desde" variant="outlined" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikDateRangeInput name="fechaHasta" label="Fecha Hasta" variant="outlined" />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormikSelect name="provinciaOrigen" label="Provincia de Origen" loading={searchModel?.isFetching} variant="outlined">
                  <MenuItem value="">Todas</MenuItem>
                  {provinciasFiltradas.map((p) => (
                    <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>
                  ))}
                </FormikSelect>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikTextField name="localidadOrigen" label="Localidad de Origen" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikSelect name="provinciaDestino" label="Provincia de Destino" loading={searchModel?.isFetching} variant="outlined">
                  <MenuItem value="">Todas</MenuItem>
                  {provinciasFiltradas.map((p) => (
                    <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>
                  ))}
                </FormikSelect>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikTextField name="localidadDestino" label="Localidad de Destino" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikTextField name="nroTramoUnico" label="Nro de Tramo" type="number" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikSelect name="sentido" label="Sentido" variant="outlined">
                  <MenuItem value="Todos">Todos</MenuItem>
                  <MenuItem value="Ida">Ida</MenuItem>
                  <MenuItem value="Vuelta">Vuelta</MenuItem>
                </FormikSelect>
              </Grid>

              <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
                <Button
                  variant="text"
                  onClick={() => {
                    resetForm();
                    onClear();
                  }}
                >
                  Limpiar
                </Button>
                <Button variant="contained" color="primary" type="submit">
                  Buscar
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </StyledPaper.Container>
  );
};

export default BuscarTramosFilterPT;